var _path, _g, _path2, _path3, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecrementIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6083_3805",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H40V40H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6083_3805)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0036 2.6302C12.9556 2.6302 6.65768 6.83917 3.95971 13.3527C1.26174 19.8672 2.73926 27.2978 7.72371 32.2843C11.0034 35.5648 15.3666 37.3727 20.008 37.3727H20.0089C22.2971 37.3727 24.5319 36.9277 26.6499 36.0501C33.1627 33.3524 37.3707 27.053 37.3707 20.0014C37.3602 10.5269 29.719 2.79256 20.28 2.63371L20.0036 2.6302ZM20.006 40.0002C11.8902 40.0002 4.63857 35.1541 1.53173 27.6541C-1.57422 20.1541 0.12791 11.5984 5.86691 5.85799C9.6432 2.08079 14.6654 0 20.0087 0C22.6444 0 25.2169 0.512519 27.6569 1.52352C35.155 4.63022 40 11.8827 40 20.0014C39.986 31.0153 31.0173 39.987 20.0052 40.0002H20.006Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6243 18.619H23.8798H21.3933H9.37483C9.32219 18.619 9.27832 18.6629 9.27832 18.7156V21.2948C9.27832 21.3484 9.32219 21.3914 9.37483 21.3914H21.3933V21.4002H30.6243L30.7349 21.2887V18.7296C30.7349 18.6691 30.6849 18.619 30.6243 18.619Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6083_3805",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H40V40H0V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6083_3805)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0036 2.6302C12.9556 2.6302 6.65768 6.83917 3.95971 13.3527C1.26174 19.8672 2.73926 27.2978 7.72371 32.2843C11.0034 35.5648 15.3666 37.3727 20.008 37.3727H20.0089C22.2971 37.3727 24.5319 36.9277 26.6499 36.0501C33.1627 33.3524 37.3707 27.053 37.3707 20.0014C37.3602 10.5269 29.719 2.79256 20.28 2.63371L20.0036 2.6302ZM20.006 40.0002C11.8902 40.0002 4.63857 35.1541 1.53173 27.6541C-1.57422 20.1541 0.12791 11.5984 5.86691 5.85799C9.6432 2.08079 14.6654 0 20.0087 0C22.6444 0 25.2169 0.512519 27.6569 1.52352C35.155 4.63022 40 11.8827 40 20.0014C39.986 31.0153 31.0173 39.987 20.0052 40.0002H20.006Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecrementIconWhite);
export default __webpack_public_path__ + "static/media/decrement-icon-white.a78744330f14f1b0e2a921488046cc8b.svg";
export { ForwardRef as ReactComponent };